import Resources from './Resources.container';

export default Resources;